module.exports = __webpack_public_path__ + "img/section-2-child2.844ba8e6.png";